import { Button, Tabs, TabsProps } from "antd";
import { FC, MouseEventHandler, useEffect, useRef, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { GLOB } from "src/util/Glob";
import './TabSticky.less';

const DELTA = 4;

const XmTabsSticky: FC<TabsProps> = ({ children, className, ...props }) => {
  const divRef = useRef<HTMLDivElement>();
  const leftScrollInterval = useRef(0);
  const rightScrollInterval = useRef(0);

  const onLeftEnter: MouseEventHandler<HTMLElement> = e => {
    leftScrollInterval.current = scrollInterval(-DELTA);
  }

  const onLeftLeave = () => {
    clearInterval(leftScrollInterval.current);
  }

  const onRightEnter = () => {
    rightScrollInterval.current = scrollInterval(DELTA);
  }

  const onRightLeave = () => {
    clearInterval(rightScrollInterval.current);
  }

  const [extra, setExtra] = useState<TabsProps['tabBarExtraContent']>({
    left: <Button type="text" title="Scroll tabs left as with mouse wheel" onMouseEnter={onLeftEnter} onMouseLeave={onLeftLeave}><FaChevronLeft /></Button>,
    right: <Button type="text" title="Scroll tabs right as with mouse wheel" onMouseEnter={onRightEnter} onMouseLeave={onRightLeave}><FaChevronRight /></Button>
  });

  function scrollInterval(delta: number) {
    return window.setInterval(() => {
      divRef.current.querySelector(':scope > .xm-tab-sticky > .ant-tabs-nav > .ant-tabs-nav-wrap').dispatchEvent(new WheelEvent('wheel', { deltaX: delta }));
    }, 20);
  }

  useEffect(() => {
    GLOB.multiTimeout(() => {
      //TODO: is there better way to detect nav operations present?
      const ops = divRef.current.querySelector<HTMLElement>(':scope > .xm-tab-sticky > .ant-tabs-nav > .ant-tabs-nav-operations');
      if (!ops?.checkVisibility?.({ visibilityProperty: true })) {
        // cannot have initial null, otherwise last tab is hidden
        setExtra(null);
      }
    });

    return () => {
      onLeftLeave();
      onRightLeave();
    }
  }, []);

  return <div className="xm-tab-sticky-parent" ref={divRef}>
    <Tabs className={"xm-tab-sticky " + (className || '')}
      tabBarExtraContent={extra}
      {...props}>
      {children}
    </Tabs>
  </div>
}

export default XmTabsSticky
